import { useMemo } from "react";
import { apiGet } from "../utils/apiClient";

export const BANNER_MESSAGES_ENDPOINT = "/alerts";

export const BANNER_REQUEST_TIMEOUT_MS = 20 * 1000;

// The banner must never reach the SignedOutSplash path; see DR 2026-09-30.
export const BANNER_REQUEST_OPTIONS = {
  suppressSessionExpired: true,
  timeoutMs: BANNER_REQUEST_TIMEOUT_MS,
};

/**
 * Retrieves app-wide alerts from the anonymous proxy route.
 * @returns - A promise that resolves to the banner message data.
 */
export const useFetchBannerMessages = () => {
  const memoizedFetchBannerMessages = useMemo(
    () => async () => {
      // Inlined so webpack drops the fixture import from a production build.
      if (
        process.env.NODE_ENV !== "production" &&
        process.env.REACT_APP_BANNER_MOCK === "true"
      ) {
        const { mockBannerResponse } = await import(
          "../utils/__fixtures__/bannerMessages.fixtures"
        );
        return { success: true, data: mockBannerResponse };
      }
      return apiGet(
        BANNER_MESSAGES_ENDPOINT,
        "fetching alerts",
        BANNER_REQUEST_OPTIONS
      );
    },
    []
  );

  return memoizedFetchBannerMessages;
};
